import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, useSlots, onMounted, onUnmounted } from 'vue';

interface Props {
  theme?: 'white' | 'black';
  value?: string;
  placeholder?: string;
  disabled?: boolean;
  type?: string;
  readonly?: boolean;
  search?: (data: string) => any;
  select?: (data: any) => any;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars

export default /*#__PURE__*/_defineComponent({
  __name: 'Input',
  props: {
    theme: { default: 'white' },
    value: { default: '' },
    placeholder: { default: '' },
    disabled: { type: Boolean, default: false },
    type: { default: 'text' },
    readonly: { type: Boolean },
    search: null,
    select: null
  },
  emits: ['input', 'focus', 'blur'],
  setup(__props: any, { emit }) {

const props = __props as { theme: 'white' | 'black', value: string, placeholder: string, disabled: boolean, type: string, readonly?: boolean, search?: (data: string) => any, select?: (data: any) => any };

const slots = useSlots();


const themeClass = computed(() =>
  props.theme ? `tui-theme-${props.theme}` : ''
);



const tuiInputRef = ref<HTMLInputElement | null>(null);
const inputRef = ref<HTMLInputElement | null>(null);
const show = ref(false);

const blur = (event: any) => {
  const { value } = event.target;
  show.value = false;
  const trimmedValue = value.trimStart().trimEnd();
  if (value !== trimmedValue) {
    event.target.value = trimmedValue;
  }
  emit('blur', tuiInputRef.value);
};
const focus = () => {
  show.value = true;
  emit('focus', tuiInputRef.value);
};
const handleSuffixIconClick = () => {
  inputRef.value?.blur();
};

const closeOnOutsideClick = (event: any) => {
  if (!tuiInputRef.value?.contains(event.target)) {
    show.value = false;
  }
};

function handleResultItemClick(item: any) {
  inputRef.value?.blur();
  if (props.select) {
    props.select(item);
  }
}

onMounted(() => {
  window.addEventListener('click', closeOnOutsideClick);
});

onUnmounted(() => {
  window.removeEventListener('click', closeOnOutsideClick);
});

const searchResult = ref<any>([]);
function handleInput(event: any) {
  const { value } = event.target;
  const trimmedValue = value.trimStart();

  if (value !== trimmedValue) {
    event.target.value = trimmedValue;
  }

  emit('input', trimmedValue);
  if (props.search) {
    searchResult.value = props.search(event.target.value);
  }
}
const showResults = computed(
  () => searchResult.value && searchResult.value?.length !== 0 && show.value
);

const hasSuffixIcon = computed(() => !!slots.suffixIcon);

return { __sfc: true,slots, props, themeClass, emit, tuiInputRef, inputRef, show, blur, focus, handleSuffixIconClick, closeOnOutsideClick, handleResultItemClick, searchResult, handleInput, showResults, hasSuffixIcon }
}

})